import { render, staticRenderFns } from "./StatusFacets.vue?vue&type=template&id=1546b891&scoped=true"
import script from "./StatusFacets.vue?vue&type=script&lang=js"
export * from "./StatusFacets.vue?vue&type=script&lang=js"
import style0 from "./StatusFacets.vue?vue&type=style&index=0&id=1546b891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546b891",
  null
  
)

export default component.exports